
import { defineComponent } from 'vue'
import Text from './common/Text.vue'

export default defineComponent({
  components: {
    Text,
  },
  data() {
    return {
      previewImage: '',
    }
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
    formattedHeader() {
      return this.$t('home.mealInput.header').replace(/\n/g, '<br>')
    },
    formattedDesc() {
      return this.$t('home.mealInput.desc').replace(/\n/g, '<br>')
    },
  },
  watch: {
    currentLanguage(newLang) {
      this.updatePreviewImage(newLang)
    },
  },
  methods: {
    updatePreviewImage(lang: string) {
      const assetLang = lang === 'jp' ? 'ja' : lang
      try {
        this.previewImage = require(`@/assets/pages/home/screens/meal-input-${assetLang}.png`)
      } catch (e) {
        this.previewImage = require('@/assets/pages/home/screens/meal-input-en.png')
      }
    },
  },
  created() {
    this.updatePreviewImage(this.currentLanguage)
  },
})
